// src/components/ProtectedComponent.js
import React from 'react';
import { usePermissions } from '../hooks/usePermissions';

// Composant pour protéger les fonctionnalités basées sur les permissions granulaires
const ProtectedComponent = ({ 
  module, 
  sousModule, 
  action, 
  fallback = null, 
  children 
}) => {
  const { hasGranularPermission, loading } = usePermissions();

  // Pendant le chargement des permissions, ne rien afficher
  if (loading) return null;

  // Vérifier si l'utilisateur a la permission requise
  const hasAccess = hasGranularPermission(module, sousModule, action);

  // Si l'utilisateur a la permission, afficher le contenu, sinon le fallback
  return hasAccess ? children : fallback;
};

export default ProtectedComponent;